<template>
    <CodiceFeanorView tool-module="affine" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
